import React from 'react'
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux'

const NotFoundPage = () => {

    return (
        <div className="">
            <div className="component-title list-group" id="working-area">
                <div className="container h-100">
                    <div className="row h-100 justify-content-center align-items-center">
                        <div className="col-6 not-found-container">
                        <div className="card not-found-message">
                            <h3 className="card-header not-found-header">404</h3>
                            <div className="card-body not-found-body">
                                <h3 className="card-title">Page Not Found</h3>
                                <p className="card-text">The page you are trying to access does not exist or is restricted</p>
                                <Link className="card-link" to="/">Back to Dashboard</Link>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    )
}

function mapStateToProps(state, ownProps) {
    return {
        state,
        ...ownProps
    }
}

export default withRouter(connect(mapStateToProps)(NotFoundPage))


// WEBPACK FOOTER //
// ./src/components/notFoundPage.js